import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  events: [],
  singleEvent: {},
  loading: false,
  formLoading: false,
  error: false,
  success: false,
  exportLoading: false,
  downloadLink: '',
  eventCreated: 0,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Calendar/index.js